import { Injectable } from '@angular/core';
import { TenantSocketEvent } from '@jms/model';
import { BehaviorSubject } from 'rxjs';
import { SocketConnection } from './socket.connection';

@Injectable({ providedIn: 'root' })
export class TenantNotificationService {

    private _tenant$ = new BehaviorSubject<any>(null);
    private _user$ = new BehaviorSubject<any>(null);

    public readonly tenant$ = this._tenant$.asObservable();
    public readonly user$ = this._user$.asObservable();

    constructor(
        private readonly socket: SocketConnection,
    ) {

        this.socket.socket.on(TenantSocketEvent.Tenant, (data) => {
            this._tenant$.next(data);
        });

        this.socket.socket.on(TenantSocketEvent.User, (data) => {
            this._user$.next(data);
        });

    }


}